import React from 'react';
import ButtonComponent from '../../../../../components/Buttons/ButtonComponent';
import Grid from '@mui/material/Grid';
import CustomizeButtonComponent from '../../../../../components/Buttons/CustomizeButtonComponent';

const ButtonCashAdvanceSettlement = ({
    ReloadData,
    AddCAS,
    EditCAS,
    DeleteData,
    Print,
    RePrint,
    HandleStatus,
    DropDownTitle,
    DataRegUserAccess
}) => {

    const renderButtonByAccessCode = (accessCode) => {
        switch (accessCode) {
            case 'CRE':
                return ButtonComponent.AddButton(AddCAS, 'New');
            case 'REI':
                return ButtonComponent.EditButton(EditCAS, 'Data');
            case 'DEL':
                return DropDownTitle !== 'Deleted' && ButtonComponent.DeleteButton(DeleteData, 'Data');
            case 'PRI':
                return DropDownTitle !== 'Deleted' && ButtonComponent.PrintButton(Print);
            case 'RPR':
                return DropDownTitle !== 'Deleted' && ButtonComponent.ReprintButton(RePrint, 'Approval');
            default:
                return null;
        }
    };

    return (
        <div className="row">
            <div className='col-12'>
                <Grid container item spacing={1} direction="row" style={{ maxWidth: '100vw', margin: '0px', columnGap: '8px', rowGap: '10px' }}>
                    {ButtonComponent.ReloadButton(ReloadData)}

                    {DataRegUserAccess.map((data) => (
                        <React.Fragment key={data.accessId}>
                            {renderButtonByAccessCode(data.accessCode)}
                        </React.Fragment>
                    ))}

                    {CustomizeButtonComponent.DropDownButtonStatus(HandleStatus, DropDownTitle)}
                </Grid>
            </div>
        </div>
    );
};

export default ButtonCashAdvanceSettlement;